import { render } from "./ViewNew.vue?vue&type=template&id=48ab00f6"
import script from "./ViewNew.vue?vue&type=script&lang=js"
export * from "./ViewNew.vue?vue&type=script&lang=js"

import "./ViewNew.vue?vue&type=style&index=0&id=48ab00f6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__